import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { Alert, Spinner } from 'react-bootstrap';

const typeLabels = {
    1: 'מנהל מוסד',
    2: 'בודק',
    3: 'מחלקות',
    4: 'מנהל מערכת',
    5: 'דשבורד',
};

const typeRoutes = {
    1: '/principal',
    2: '/checker',
    3: '/departments',
    4: '/admin',
    5: '/dash',
};

const SelectAccount = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        axios.get('/api/auth/pending-users')
            .then(res => {
                if (res.data.msg === 'ok') {
                    setUsers(res.data.users);
                } else {
                    navigate('/');
                }
            })
            .catch(() => navigate('/'))
            .finally(() => setLoading(false));
    }, [navigate]);

    const handleSelect = (index) => {
        setLoading(true);
        axios.post('/api/auth/select-account', { index })
            .then(res => {
                if (res.data.msg === 'ok') {
                    const user = users[index];
                    sessionStorage.setItem('usertype', user.type);
                    sessionStorage.setItem('name', user.name);
                    sessionStorage.setItem('semel', user.semel);
                    sessionStorage.setItem('email', user.email);
                    if (user.mosName) sessionStorage.setItem('mosName', user.mosName);
                    if (user.city) sessionStorage.setItem('city', user.city);
                    navigate(typeRoutes[res.data.type] || '/');
                } else {
                    setError('שגיאה בבחירת חשבון');
                }
            })
            .catch(() => setError('שגיאה בבחירת חשבון'))
            .finally(() => setLoading(false));
    };

    if (loading) {
        return (
            <div className="container pt-5 text-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <div className="container pt-5" dir="rtl">
            <Row className="justify-content-md-center mb-3">
                <Col xs={12} md={8} lg={6}>
                    <h4 className="text-center mb-4">נמצאו מספר חשבונות עבור המייל שלך</h4>
                    <p className="text-center text-muted">נא לבחור את החשבון שברצונך להתחבר אליו:</p>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {users.map((user, i) => (
                        <Card key={i} className="shadow-sm mb-3">
                            <Card.Body className="d-flex justify-content-between align-items-center">
                                <div>
                                    <div><strong>{user.mosName || `סמל ${user.semel}`}</strong></div>
                                    <div className="text-muted">סמל: {user.semel} | תפקיד: {typeLabels[user.type] || user.type}</div>
                                </div>
                                <Button variant="primary" onClick={() => handleSelect(i)}>
                                    בחר
                                </Button>
                            </Card.Body>
                        </Card>
                    ))}
                </Col>
            </Row>
        </div>
    );
};

export default SelectAccount;
